<main class="container-fluid">
  <div class="side-bar" *ngIf="user">
    <h1 class="subtitle mb-1">Mijn Dashboard</h1>
    <p class="profile-text fs-6 mb-1">Welkom, {{ user.name }}</p>
    <p class="profile-text fs-6">Gebruiker sinds {{ user.created | slice:6:10  }}</p>
  </div>
  <ik-image
    urlEndpoint="https://ik.imagekit.io/demo/"
    path="default-image.jpg">
  </ik-image>
  <div class="profile-container gap-3">
    <div class="w-100" *ngIf="user">
      <h1 class="subtitle" *ngIf="!user.admin && !user.superAdmin">Profiel</h1>
      <h1 class="subtitle" *ngIf="user.admin || user.superAdmin">Profiel - (Admin)</h1>
      <table class="profile-details">
        <tr>
          <td class="profile-text">Gebruikersnaam</td>
          <td>{{ user.name }}</td>
        </tr>
        <tr>
          <td class="profile-text">E-mailadres</td>
          <td>{{ user.email }}</td>
        </tr>
        <tr>
          <td class="profile-text">Aanmaakdatum account</td>
          <td>{{ user.created }}</td>
        </tr>
      </table>
      <div class="row button-row">
        <button class="btn btn-primary profile-button mt-3" routerLink="/profiel/gegevens">
          Accountgegevens wijzigen
        </button>
      </div>
      <div class="row button-row">
        <button class="btn btn-primary profile-button mt-3" routerLink="/profiel/gegevens/wachtwoord-wijzigen">
          Wachtwoord wijzigen
        </button>
      </div>
      <div class="row button-row" *ngIf="user.admin || user.superAdmin">
        <button class="btn btn-primary profile-button mt-3" routerLink="/admin/beheer-gebruikers">
          Admin omgeving
        </button>
      </div>
      <div class="row button-row">
        <button class="btn btn-primary profile-button mt-3" (click)="signOut()">
          Uitloggen
        </button>
      </div>
    </div>
    <h2 class="subtitle mt-5">Activiteiten</h2>
    <div class="profile-activities">
      <h2 class="subtitle mt-5">{{ registerCounter }} Activiteit(en)</h2>
      <p>Je bent momenteel aangemeld voor <b>{{ registerCounter }}</b> activiteit(en)</p>
      <div class="row justify-content-center">
        <button class="btn btn-primary profile-button mt-2" routerLink="/profiel/activiteiten">
          Bekijken
        </button>
      </div>
    </div>
  </div>
</main>

